import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AnnounceSend.css';

const API_BASE = process.env.REACT_APP_API_BASE;

const AnnounceSend = () => {
    const [announcementText, setAnnouncementText] = useState('');
    const [target, setTarget] = useState('both'); // Standard: Beides
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [userData, setUserData] = useState(null);

    // Ziel-Optionen (Gekürzt auf die gewünschten 3)
    const targetOptions = [
        {
            id: 'both',
            title: '🌟 Discord & Dashboard',
            subtitle: 'Maximale Reichweite',
            description: 'Erscheint sowohl im Dashboard als auch auf Discord.',
            icon: '🌟',
            color: 'success',
            badge: 'EMPFOHLEN',
            reach: 'Discord und Dashboard Teamler',
            features: ['Dashboard + Discord', 'Einheitliche Nachricht'],
        },
        {
            id: 'discord',
            title: '💬 Discord',
            subtitle: 'Community-weit',
            description: 'Postet die Announce nur in den Team Informationen.',
            icon: '🚀',
            color: 'primary',
            badge: 'Discord',
            reach: 'Teamler-Discord',
            features: ['Discord-Channel', 'Embed-Formatierung'],
        },
        {
            id: 'dashboard',
            title: '📱 Dashboard',
            subtitle: 'Nur Intern',
            description: 'Ankündigung ist nur im Dashboard sichtbar und erscheint nicht auf Discord.',
            icon: '🖥️',
            color: 'secondary',
            badge: 'Intern',
            reach: 'Teamler-Dashboard',
            features: ['Nur Dashboard', 'Keine Discord Nachricht'],
        }
    ];

    useEffect(() => {
        const userStr = localStorage.getItem('discord_user');
        if (userStr) {
            try {
                setUserData(JSON.parse(userStr));
            } catch (e) {
                console.error('Fehler beim Parsen der Benutzerdaten:', e);
            }
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!announcementText.trim()) {
            setError('Bitte geben Sie eine Ankündigung ein.');
            return;
        }

        // Fetch current user data from Discord API
        let currentUserData = userData;
        try {
            const token = localStorage.getItem('discord_token');
            if (token) {
                const response = await axios.get('https://discord.com/api/users/@me', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                currentUserData = {
                    ...userData,
                    username: response.data.username,
                    displayname: response.data.global_name || response.data.username,
                    id: response.data.id,
                    avatar: response.data.avatar
                };
            }
        } catch (err) {
            console.error('Fehler beim Abrufen der Benutzerdaten:', err);
        }
        // Innerhalb der handleSubmit Funktion in AnnounceSend.js
        if (target === 'dashboard' || target === 'both') {
            const authorName = currentUserData?.displayname || currentUserData?.nickname || currentUserData?.username || 'Unbekannt';            await axios.post(`${API_BASE}/api/dashboard-announcements`, {
                content: `${authorName}: ${announcementText.trim()}`,
                author: {
                    username: authorName,
                    avatarURL: currentUserData?.avatar ?
                        `https://cdn.discordapp.com/avatars/${currentUserData.id}/${currentUserData.avatar}.png` :
                        'https://cdn.discordapp.com/embed/avatars/0.png'
                },
                target: target
            }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('discord_token')}` }
            });
        }
        setIsLoading(true);
        setError(null);
        setIsSuccess(false);

        try {
            const token = localStorage.getItem('discord_token');
            
            // Objekt für die Dashboard-Anzeige erstellen
            const authorName = currentUserData?.displayname || currentUserData?.username || 'Unbekannt';
            const dashboardMsg = {
                id: Date.now().toString(),
                content: `${authorName}: ${announcementText.trim()}`,
                type: target,
                created_at: new Date().toISOString(),
                author: {
                    username: authorName,
                    avatarURL: currentUserData?.avatar ?
                        `https://cdn.discordapp.com/avatars/${currentUserData.id}/${currentUserData.avatar}.png` :
                        '/default_avatar.png'
                }
            };

            // LOGIK: An Discord senden
            if (target === 'discord' || target === 'both') {
                if (!token) throw new Error('Kein Discord Token gefunden. Bitte neu einloggen.');

                await axios.post(`${API_BASE}/api/announcements`, {
                    content: announcementText.trim(),
                    author: {
                        username: currentUserData?.displayname || currentUserData?.username || 'Unbekannt',
                        avatarURL: currentUserData?.avatar ?
                            `https://cdn.discordapp.com/avatars/${currentUserData.id}/${currentUserData.avatar}.png` :
                            'https://cdn.discordapp.com/embed/avatars/0.png'
                    },
                    target: target
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }

            // LOGIK: Im Dashboard speichern (localStorage für das Widget)
            if (target === 'dashboard' || target === 'both') {
                const existing = JSON.parse(localStorage.getItem('dashboard_announcements') || '[]');
                existing.unshift(dashboardMsg); // Neue Nachricht nach oben
                localStorage.setItem('dashboard_announcements', JSON.stringify(existing));
            }

            // Erfolg
            setIsSuccess(true);
            setAnnouncementText('');
            setTimeout(() => setIsSuccess(false), 3000);

        } catch (err) {
            console.error('Fehler:', err);
            setError(err.response?.data?.error || err.message || 'Fehler beim Senden');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="announce-send-container">
            <div className="dashboard-main">
            <div className="hero-panel">
                <div>
                    <h2 style={{ margin: 0, fontSize: '1.8rem' }}>📢 Ankündigung senden</h2>
                    <p className="muted small">Wählen Sie den Zielkanal für Ihre Nachricht</p>
                </div>
                {userData && (
                    <div className="user-info">
                        <img 
                            src={userData.avatar ? `https://cdn.discordapp.com/avatars/${userData.id}/${userData.avatar}.png` : '/default_avatar.png'} 
                            alt={userData.username}
                            className="user-avatar"
                        />
                        {/* Hier die Priorität anpassen */}
                        <span>{userData.displayname || userData.nickname || userData.username}</span>
                    </div>
                )}
            </div>
            
            <div className="grid">
                <div className="card">
                    <div className="card-header">
                        <h4>Neue Ankündigung</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label className="form-label">🎯 Ziel wählen *</label>
                                <div className="target-selection-grid">
                                    {targetOptions.map((option) => (
                                        <div 
                                            key={option.id}
                                            className={`target-option-card ${target === option.id ? 'selected' : ''}`}
                                            onClick={() => { setTarget(option.id); setError(null); }}
                                        >
                                            <div className="target-option-header">
                                                <div className="target-option-icon">{option.icon}</div>
                                                <div className={`target-option-badge badge-${option.color}`}>
                                                    {option.badge}
                                                </div>
                                            </div>
                                            <div className="target-option-content">
                                                <h4 className="target-option-title">{option.title}</h4>
                                                <p className="target-option-description">{option.description}</p>
                                                <div className="target-option-reach">
                                                    <span className="reach-label">Erreicht: </span>
                                                    <span className="reach-value">{option.reach}</span>
                                                </div>
                                            </div>
                                            <div className={`selection-indicator ${target === option.id ? 'active' : ''}`}>
                                                {target === option.id && <span className="selection-check">✓</span>}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="announcement-text">Nachricht</label>
                                <textarea
                                    id="announcement-text"
                                    value={announcementText}
                                    onChange={(e) => { setAnnouncementText(e.target.value); setError(null); }}
                                    placeholder="Schreibe hier deine Ankündigung..."
                                    rows={6}
                                    disabled={isLoading}
                                    className="form-textarea"
                                />
                            </div>

                            {error && (
                                <div className="alert alert-error">
                                    <span className="alert-icon">⚠️</span>
                                    <span>{error}</span>
                                </div>
                            )}

                            {isSuccess && (
                                <div className="alert alert-success">
                                    <span className="alert-icon">✅</span>
                                    <span>Ankündigung erfolgreich veröffentlicht!</span>
                                </div>
                            )}

                            <div className="form-actions">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary"
                                    disabled={isLoading || !announcementText.trim()}
                                >
                                    {isLoading ? 'Wird gesendet...' : '📢 Ankündigung senden'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h4>💡 Hinweise</h4>
                    </div>
                    <div className="card-body">
                        <ul className="tips-list">
                            <li><strong>Beides:</strong> Postet auf Discord UND zeigt es oben im Dashboard Home an.</li>
                            <li><strong>Discord:</strong> Nur für die Community sichtbar.</li>
                            <li><strong>Dashboard:</strong> Nur für Leute mit Dashboard-Zugriff sichtbar.</li>
                            <li>Nutze Markdown für Discord (z.B. **Fett**).</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default AnnounceSend;